<template>
  <div
    class="c-pull"
    :class="{ 'c-visible': showPullToRefresh }"
  >
    <v-progress-circular
      color="primary"
      indeterminate
    />
  </div>
</template>

<script>
export default {
  name: 'PullToRefresh',

  components: {},

  model: {
    prop: 'refresh',
    event: 'update:refresh'
  },

  props: {
    refresh: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      showPullToRefresh: false,
      threshold: 40,
      touchstartY: 0
    }
  },

  watch: {
    refresh: {
      immediate: true,
      handler: function (newValue, _oldValue) {
        this.showPullToRefresh = newValue
      }
    }
  },

  mounted: function () {
    document.addEventListener('touchstart', this.onStart)
    document.addEventListener('touchmove', this.onMove)
    document.addEventListener('touchend', this.onEnd)
  },

  beforeDestroy: function () {
    document.removeEventListener('touchstart', this.onStart)
    document.removeEventListener('touchmove', this.onMove)
    document.removeEventListener('touchend', this.onEnd)
  },

  methods: {
    onStart(e) {
      this.touchstartY = e.touches[0].clientY
    },

    onMove(e) {
      const touchY = e.touches[0].clientY
      const deltaY = touchY - this.touchstartY

      // determine whether threshold is reached
      if (deltaY > this.threshold && window.scrollY <= 0) {
        this.showPullToRefresh = true
        e.preventDefault() // disable scrolling
      } else {
        this.showPullToRefresh = false
      }
    },

    onEnd(_e) {
      // determine whether a refresh was triggered
      if (this.showPullToRefresh) {
        this.$emit('update:refresh', true)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.c-pull {
  position: fixed;
  top: -48px;
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: top 0.7s ease-in-out;
  z-index: 2;
}

.c-pull.c-visible {
  top: 0px;
}
</style>
